import React, { type PropsWithChildren } from "react";

import clsx from "clsx";

export type CardProps = {
  className?: string;
};

export function Card({ children, className }: PropsWithChildren<CardProps>) {
  return (
    <div
      className={clsx(
        "container 2xl:w-[43rem] xl:w-[40rem] lg:w-[30rem] md:w-[25rem] shadow-card",
        className,
      )}
    >
      {children}
    </div>
  );
}
